let slickDefaults = require('../slick-default/slick-default');
let debounce = require('../../modules/debounce');
require('./news-list.less');

let size = require('../../modules/size');

jQuery(function() {
    var $newsSlider = $('.js-slick-news-list');

    function setNewsSlider() {
        $newsSlider.each(function() {
            var $this = $(this);
            if (window.innerWidth >= size.mobileBig) {
                if ($this.hasClass('slick-initialized')) $this.slick('unslick');
            } else {
                if (!$this.hasClass('slick-initialized')) {
                    $this.slick(
                        $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
                            slidesToShow: 1,
                            dots: true
                        })
                    );
                }
            }
        });
    }

    setNewsSlider();
    debounce.setResizeDebounce(setNewsSlider);
});



// WEBPACK FOOTER //
// ./blocks/news-list/news-list.js